import { render, staticRenderFns } from "./AdminRoleForm.vue?vue&type=template&id=22e59be6"
import script from "./AdminRoleForm.vue?vue&type=script&lang=ts"
export * from "./AdminRoleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports